import { Button } from '@/components/ui/button';

export function EditConflict({ current, draft, onContinue }: {
  current: string; draft: string; onContinue: () => void;
}) {
  return <section role="alert" className="shrink-0 rounded-md border border-line bg-sunk p-s3 text-meta">
    <p className="m-0">다른 사람이 수정했다. 내 초안은 유지했다. 아래 내용을 비교한 뒤 필요한 변경을 반영해 주세요.</p>
    <div className="my-s3 grid gap-s3 md:grid-cols-2">
      <details><summary>서버의 현재 내용</summary><pre className="max-h-48 overflow-auto whitespace-pre-wrap text-small">{current}</pre></details>
      <details><summary>내 초안</summary><pre className="max-h-48 overflow-auto whitespace-pre-wrap text-small">{draft}</pre></details>
    </div>
    <Button variant="outline" onClick={onContinue}>현재 버전을 확인하고 내 초안 계속 편집</Button>
  </section>;
}
